import doc                          from '@widesk-core/decorators/doc';
import AbstractWebsiteLanguageModel from './AbstractWebsiteLanguageModel';
import model                        from '@widesk-core/decorators/model';
import translationStore             from '@widesk-ui/stores/translationStore';
import { computed }                 from 'mobx';

@doc.urnResource('website_language')
@model.cacheDuration()
export default class WebsiteLanguageModel extends AbstractWebsiteLanguageModel {
	@computed get image() {
		return translationStore.get(this.language.locale)?.image || '';
	}
}
